// Ensure this file is treated as a module
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faTimesCircle, faExternalLinkAlt, faSync } from "@fortawesome/free-solid-svg-icons";
import "./QrScanResult.css";

export interface QrScanResultProps {
  result: {
    success: boolean;
    message: string;
    name?: string;
    email?: string;
    applicationId?: string;
    attendeeType?: string;
    error?: string;
  };
  onReset: () => void;
  onViewApplication?: (applicationId: string) => void;
}

const QrScanResult: React.FC<QrScanResultProps> = ({ result, onReset, onViewApplication }) => {
  if (result.success) {
    return (
      <div className="qrscanresult-root success">
        <div className="qrscanresult-card">
          <div className="qrscanresult-icon success">
            <FontAwesomeIcon icon={faCheckCircle} size="2x" />
          </div>
          <h2 className="qrscanresult-title">Check-In Successful</h2>
          <p className="qrscanresult-message">{result.message}</p>
          <div className="qrscanresult-details">
            <div className="qrscanresult-row">
              <span className="qrscanresult-label">Name:</span>
              <span className="qrscanresult-value">{result.name}</span>
            </div>
            <div className="qrscanresult-row">
              <span className="qrscanresult-label">Email:</span>
              <span className="qrscanresult-value">{result.email}</span>
            </div>
            <div className="qrscanresult-row">
              <span className="qrscanresult-label">Type:</span>
              <span className="qrscanresult-value">{result.attendeeType === "single" ? "Single Attendee" : "Couple"}</span>
            </div>
          </div>
          <div className="qrscanresult-actions">
            {result.applicationId && onViewApplication && (
              <button
                className="qrscanresult-view-btn"
                onClick={() => onViewApplication(result.applicationId!)}
              >
                <FontAwesomeIcon icon={faExternalLinkAlt} /> View Application
              </button>
            )}
            <button className="qrscanresult-reset-btn" onClick={onReset}>
              <FontAwesomeIcon icon={faSync} /> Scan Another
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Failure UI
  return (
    <div className="qrscanresult-root qrscanresult-error">
      <div className="qrscanresult-card">
        <div className="qrscanresult-icon qrscanresult-error-icon">
          <FontAwesomeIcon icon={faTimesCircle} size="2x" />
        </div>
        <h2 className="qrscanresult-title">Check-In Failed</h2>
        <div className="qrscanresult-error-detail">
          <p className="qrscanresult-error-message">{result.error || result.message}</p>
        </div>
        <button className="qrscanresult-reset-btn" onClick={onReset}>
          <FontAwesomeIcon icon={faSync} /> Try Again
        </button>
      </div>
    </div>
  );
};

export default QrScanResult;
